import { Globe as GlobeIcon, Lock as LockIcon } from 'react-feather'
import { colors } from '@material-ui/core'

import theme from 'theme'
import tours from './tours'
import permissions from './permissions'

const {
  MAIN_STEP_3,
  MAIN_STEP_4,
  MAIN_STEP_6,
  MANAGEMENT_ACCEPTED_STEP_2,
  MANAGEMENT_ACCEPTED_STEP_3,
  MANAGEMENT_ACCEPTED_STEP_4,
} = tours.documents

const ADVISOR_CARD_DOCUMENT = 'advisor-company-document'
const ADVISOR_CARD_CLOSED = 'closed'

const DOCUMENTS_CATEGORY_ID = 'documents'
const DOCUMENT_TEMPLATES_CATEGORY_ID = 'document-templates'
const PENDING_APPROVAL_DOCUMENTS_CATEGORY_ID = 'pending-approval-documents'
const ACCEPTED_DOCUMENTS_CATEGORY_ID = 'accepted'
const APPROVAL_DOCUMENTS_CATEGORY_ID = 'approval'
const HISTORY_DOCUMENTS_CATEGORY_ID = 'history'
const SETTINGS_DOCUMENTS_CATEGORY_ID = 'settings'
const CONTROLS_DOCUMENTS_CATEGORY_ID = 'controls'

const DAY_UNIT = 'day'
const MONTH_UNIT = 'month'
const YEAR_UNIT = 'year'

const DRAFT_STATUS_ID = '1'
const ACTIVE_STATUS_ID = '2'
const INACTIVE_STATUS_ID = '3'
const EXPIRED_STATUS_ID = '4'
const AWAITING_APPROVAL_STATUS_ID = '5'

const AWANTING_APPROVAL_PERSON_STATUS_ID = '1'
const APPROVED_PERSON_STATUS_ID = '2'
const REPROVED_PERSON_STATUS_ID = '3'

const PRIVACY_POLICY_CATEGORY_ID = 'privacy_notice'
const COOKIE_POLICY_CATEGORY_ID = 'cookie_policy'
const TERMS_OF_USE_CATEGORY_ID = 'terms_of_use'
const OTHER_CATEGORY_ID = 'other'
const POP_CATEGORY_ID = 'pop'

const PUBLIC_SHARING_MODE_ID = 'public'
const RESTRICTED_SHARING_MODE_ID = 'restricted'

const WRITTEN_CONTENT_KIND = 'written_content'
const ATTACHMENT_CONTENT_KIND = 'attachment_content'
const LINK_CONTENT_KIND = 'link_content'

const WRITTEN_CONTENT_LABEL = 'Escrito'
const ATTACHMENT_CONTENT_LABEL = 'Anexado'

const AUTOMATIC_GENERATION_FORM = 'automatic_generation'
const BLANK_FORM = 'blank_form'

const REAL_INCIDENT_NAME = 'Incidente Real'
const TEST_INCIDENT_NAME = 'Incidente de Teste'

const REAL_INCIDENT_VALUE = 'real'
const TEST_INCIDENT_VALUE = 'test'

const TARGET_TYPE_USER = 'User'
const TARGET_TYPE_DEPARTMENT = 'Department'

const PUBLIC_ACCESS_PERMISSION_ID = 'public_access'
const OWNER_ACCESS_PERMISSION_ID = 'owner_access'
const USER_ACCESS_PERMISSION_ID = 'user_access'
const DEPARTMENT_ACCESS_PERMISSION_ID = 'department_access'

const PERSON_APPROVAL_OPTIONS = [
  { id: AWANTING_APPROVAL_PERSON_STATUS_ID, name: 'Aguardando aprovação' },
  { id: APPROVED_PERSON_STATUS_ID, name: 'Aprovado' },
  { id: REPROVED_PERSON_STATUS_ID, name: 'Reprovado' },
]

const INCIDENT_TYPE_OPTIONS = [
  { id: REAL_INCIDENT_VALUE, name: REAL_INCIDENT_NAME },
  { id: TEST_INCIDENT_VALUE, name: TEST_INCIDENT_NAME },
]

const CATEGORY_OPTIONS = [
  { id: PRIVACY_POLICY_CATEGORY_ID, name: 'Aviso de privacidade' },
  { id: COOKIE_POLICY_CATEGORY_ID, name: 'Política de cookies' },
  { id: TERMS_OF_USE_CATEGORY_ID, name: 'Termos de uso' },
  { id: POP_CATEGORY_ID, name: 'Procedimento Operacional Padrão' },
  { id: OTHER_CATEGORY_ID, name: 'Outras' },
]

const TRANSLATION_CATEGORY = {
  [PRIVACY_POLICY_CATEGORY_ID]: 'Aviso de privacidade',
  [COOKIE_POLICY_CATEGORY_ID]: 'Política de cookies',
  [TERMS_OF_USE_CATEGORY_ID]: 'Termos de uso',
  [POP_CATEGORY_ID]: 'Procedimento Operacional Padrão',
}

const CATEGORIES_CARD_TABS = [
  {
    id: MAIN_STEP_3,
    value: DOCUMENTS_CATEGORY_ID,
    label: 'Meus documentos',
    somePermissions: [
      permissions.PRIVACY_POLICIES.LIST,
      permissions.PRIVACY_POLICIES.CREATE,
    ],
  },
  {
    id: MAIN_STEP_4,
    value: DOCUMENT_TEMPLATES_CATEGORY_ID,
    label: 'Documentos modelo',
    somePermissions: [
      permissions.PRIVACY_POLICIES.CREATE,
      permissions.DOCUMENTS_TEMPLATE.LIST,
    ],
  },
  {
    id: MAIN_STEP_6,
    value: PENDING_APPROVAL_DOCUMENTS_CATEGORY_ID,
    label: 'Pendentes de aprovação',
    permission: permissions.PRIVACY_POLICIES.LIST,
  },
]

const STATUS_OPTIONS = [
  { id: ACTIVE_STATUS_ID, name: 'Ativo' },
  { id: DRAFT_STATUS_ID, name: 'Rascunho' },
  { id: INACTIVE_STATUS_ID, name: 'Inativo' },
  { id: AWAITING_APPROVAL_STATUS_ID, name: 'Aguardando aprovação' },
  { id: EXPIRED_STATUS_ID, name: 'Expirado' },
]

const CHIP_STATUS_COLOR = {
  [ACTIVE_STATUS_ID]: theme.palette.tertiary.main,
  [INACTIVE_STATUS_ID]: colors.blueGrey[400],
  [DRAFT_STATUS_ID]: theme.palette.info.main,
  [EXPIRED_STATUS_ID]: theme.palette.warning.main,
  [AWAITING_APPROVAL_STATUS_ID]: colors.yellow[600],
}

const STATUS_LABELS = STATUS_OPTIONS.map((option) => ({
  label: option.name,
  color: CHIP_STATUS_COLOR[option.id],
}))

const CHIP_STATUS_LABEL = {
  [ACTIVE_STATUS_ID]: 'ativo',
  [INACTIVE_STATUS_ID]: 'inativo',
  [DRAFT_STATUS_ID]: 'rascunho',
  [AWAITING_APPROVAL_STATUS_ID]: 'aguardando aprovação',
  [EXPIRED_STATUS_ID]: 'expirado',
}

const DOCUMENT_DOWNLOAD_CONTROL_ITEMS = [
  {
    name: 'documentCopy',
    label: 'Cópia do documento',
  },
  {
    name: 'scienceReport',
    label: 'Relatório de aceites',
  },
]

const PUBLICATION_CONTROL_ITEMS = [
  {
    name: 'publicDocument',
    label:
      'Publicar este documento no seu canal de atendimento ao titular de dados',
  },
  {
    name: 'checkOldVersions',
    label: 'Permitir que os usuários consultem versões anteriores do documento',
  },
  {
    name: 'collectAccepted',
    label: 'Coletar aceite dos termos deste documento',
  },
  {
    name: 'collectApproval',
    label: 'Coletar aprovações deste documento',
  },
  {
    name: 'allowAutomaticEditing',
    label: 'Permitir edição automática do sistema',
  },
]

const PERMISSIONS_CONTROL_ITEMS = [
  {
    name: PUBLIC_ACCESS_PERMISSION_ID,
    label: 'Qualquer usuário da empresa pode visualizar este documento',
  },
  {
    name: OWNER_ACCESS_PERMISSION_ID,
    label: 'Apenas o criador pode visualizar este documento',
  },
  {
    name: USER_ACCESS_PERMISSION_ID,
    label: 'Apenas usuários específicos podem visualizar este documento',
  },
  {
    name: DEPARTMENT_ACCESS_PERMISSION_ID,
    label:
      'Apenas os usuários vinculados a departamentos específicos podem visualizar este documento',
  },
]

const ACCEPTANCE_STEPS = [
  { id: MANAGEMENT_ACCEPTED_STEP_2, label: 'Campos' },
  { id: MANAGEMENT_ACCEPTED_STEP_3, label: 'Pré-visualização' },
  { id: MANAGEMENT_ACCEPTED_STEP_4, label: 'Compartilhamento' },
]

const ACCEPTANCE_SHARING_OPTIONS = [
  {
    title: 'Acesso com o link',
    subtitle: 'Qualquer pessoa com o link pode visualizar',
    icon: GlobeIcon,
    value: PUBLIC_SHARING_MODE_ID,
  },
  {
    title: 'Acesso restrito',
    subtitle: 'Somente pessoas autorizadas por e-mail',
    icon: LockIcon,
    value: RESTRICTED_SHARING_MODE_ID,
  },
]

const DOWNLOAD_SNACKBAR_MESSAGE = {
  both: 'Cópia do documento e relatório de ciência baixados com sucesso! Caso o documento não abra, ative os pop-ups.',
  document:
    'Cópia do documento baixada com sucesso! Caso o documento não abra, ative os pop-ups.',
  report:
    'Relatório de ciência baixado com sucesso! Caso o documento não abra, ative os pop-ups.',
}

const CONTENT_COMPARATOR_SELECT_ITEMS = [
  { label: 'Versão de origem', name: 'originVersion' },
  { label: 'Versão a comparar', name: 'comparativeVersion' },
]

const CONTENT_KIND_ITEMS = [
  {
    id: WRITTEN_CONTENT_KIND,
    name: WRITTEN_CONTENT_LABEL,
  },
  {
    id: ATTACHMENT_CONTENT_KIND,
    name: ATTACHMENT_CONTENT_LABEL,
  },
]

const documents = {
  ACCEPTANCE_SHARING_OPTIONS,
  ACCEPTANCE_STEPS,
  ACCEPTED_DOCUMENTS_CATEGORY_ID,
  ACTIVE_STATUS_ID,
  ADVISOR_CARD_CLOSED,
  ADVISOR_CARD_DOCUMENT,
  APPROVAL_DOCUMENTS_CATEGORY_ID,
  APPROVED_PERSON_STATUS_ID,
  HISTORY_DOCUMENTS_CATEGORY_ID,
  ATTACHMENT_CONTENT_KIND,
  LINK_CONTENT_KIND,
  AUTOMATIC_GENERATION_FORM,
  AWANTING_APPROVAL_PERSON_STATUS_ID,
  AWAITING_APPROVAL_STATUS_ID,
  BLANK_FORM,
  CATEGORIES_CARD_TABS,
  CATEGORY_OPTIONS,
  CHIP_STATUS_COLOR,
  CHIP_STATUS_LABEL,
  STATUS_LABELS,
  CONTENT_COMPARATOR_SELECT_ITEMS,
  PERSON_APPROVAL_OPTIONS,
  DAY_UNIT,
  DEPARTMENT_ACCESS_PERMISSION_ID,
  DOCUMENT_DOWNLOAD_CONTROL_ITEMS,
  DOCUMENT_TEMPLATES_CATEGORY_ID,
  DOCUMENTS_CATEGORY_ID,
  PENDING_APPROVAL_DOCUMENTS_CATEGORY_ID,
  DOWNLOAD_SNACKBAR_MESSAGE,
  SETTINGS_DOCUMENTS_CATEGORY_ID,
  DRAFT_STATUS_ID,
  EXPIRED_STATUS_ID,
  INACTIVE_STATUS_ID,
  INCIDENT_TYPE_OPTIONS,
  MONTH_UNIT,
  OTHER_CATEGORY_ID,
  OWNER_ACCESS_PERMISSION_ID,
  POP_CATEGORY_ID,
  USER_ACCESS_PERMISSION_ID,
  PERMISSIONS_CONTROL_ITEMS,
  PRIVACY_POLICY_CATEGORY_ID,
  PUBLIC_ACCESS_PERMISSION_ID,
  PUBLIC_SHARING_MODE_ID,
  PUBLICATION_CONTROL_ITEMS,
  REAL_INCIDENT_NAME,
  REAL_INCIDENT_VALUE,
  RESTRICTED_SHARING_MODE_ID,
  STATUS_OPTIONS,
  TARGET_TYPE_DEPARTMENT,
  TARGET_TYPE_USER,
  TEST_INCIDENT_VALUE,
  TRANSLATION_CATEGORY,
  WRITTEN_CONTENT_KIND,
  YEAR_UNIT,
  CONTENT_KIND_ITEMS,
  CONTROLS_DOCUMENTS_CATEGORY_ID,
}

export default documents
